import React from 'react';
import './SummaryBar.css';

const SummaryBar = ({ summary, onFilterClick, activeFilter }) => {
  if (!summary) {
    return (
      <div className="summary-bar">
        <div className="summary-item">
          <span className="summary-label">Loading...</span>
        </div>
      </div>
    );
  }

  const handleClick = (filterType) => {
    if (onFilterClick) {
      // If clicking the same filter, remove it (show all)
      if (activeFilter === filterType) {
        onFilterClick(null);
      } else {
        onFilterClick(filterType);
      }
    }
  };

  return (
    <div className="summary-bar">
      <div 
        className={`summary-item summary-active ${activeFilter === 'active' ? 'active' : ''}`}
        onClick={() => handleClick('active')}
        style={{ cursor: 'pointer' }}
      >
        <span className="summary-icon">✓</span>
        <span className="summary-value">{summary.activeSites}</span>
        <span className="summary-label">Active Sites</span>
      </div>
      <div 
        className={`summary-item summary-total ${activeFilter === null ? 'active' : ''}`}
        onClick={() => handleClick(null)}
        style={{ cursor: 'pointer' }}
      >
        <span className="summary-icon">📊</span>
        <span className="summary-value">{summary.totalSites}</span>
        <span className="summary-label">Total Sites</span>
      </div>
      <div 
        className={`summary-item summary-critical ${activeFilter === 'critical' ? 'active' : ''}`}
        onClick={() => handleClick('critical')}
        style={{ cursor: 'pointer' }}
      >
        <span className="summary-icon">!</span>
        <span className="summary-value">{summary.criticalAlerts}</span>
        <span className="summary-label">Critical Alerts</span>
      </div>
      <div 
        className={`summary-item summary-warning ${activeFilter === 'warning' ? 'active' : ''}`}
        onClick={() => handleClick('warning')}
        style={{ cursor: 'pointer' }}
      >
        <span className="summary-icon">⚠</span>
        <span className="summary-value">{summary.warningAlerts}</span>
        <span className="summary-label">Warning Alerts</span>
      </div>
      <div 
        className={`summary-item summary-issues ${activeFilter === 'issues' ? 'active' : ''}`}
        onClick={() => handleClick('issues')}
        style={{ cursor: 'pointer' }}
      >
        <span className="summary-icon">🔧</span>
        <span className="summary-value">{summary.sitesWithIssues}</span>
        <span className="summary-label">Sites with Issues</span>
      </div>
    </div>
  );
};

export default SummaryBar;

